<div class="consent-informations p-4">
  <div class="container">
    <div class="card consent-card shadow-sm p-3">
      <div class="card-header">
        <h5 class="fw-normal">{{ "consent.title" | t }}</h5>
      </div>
      <div class="card-body">
        {{ "consent.examination" | t }}
        <br /><br />
        {{ "consent.paragraph1" | t }}
        <br /><br />
        {{ "consent.paragraph2" | t }}
        <br /><br />
        {{ "consent.singlePrice" | t }}
        <br /><br />
        {{ "consent.includedTitle" | t }}
        <ul>
          <li *ngFor="let item of subList">{{ item }}</li>
        </ul>

        <br />
        {{ "consent.multiplePrice" | t }}
        <br /><br />
        {{ "consent.absenceTitle" | t }}
        <br /><br />
        {{ "consent.cancellation48" | t }}
        <br /><br />
        {{ "consent.cancellation24" | t }}
        <br /><br />
        {{ "consent.sameDay" | t }}
      </div>
    </div>
  </div>
</div>
